<div class="row justify-content-between">
  <section class="col-6 col-xl-4" id="slots-before">
    <app-button [title]="'earlier' | translate" (click)="onPrevSlot()" [buttonCssClass]="'button button-left button-black float-left'"></app-button>
  </section>
  <section class="col-6 col-xl-4">
    <app-button [title]="'later' | translate" (click)="onNextSlot()" [buttonCssClass]="'button button-right button-black float-right'"></app-button>
  </section>
</div>
